// https://schema.org/VideoObject

// Status: not used! But see VideoObject.java and EditVideoForm elsewhere in jsx

import DataClass from '../base/data/DataClass';
import Dt from '../base/data/Dt.ts';

class VideoObject extends DataClass {
	constructor(base) {
		super(base);
		Object.assign(this, base);
	}
}
DataClass.register(VideoObject, "VideoObject");
const This = VideoObject;
export default VideoObject;


/**
 * This is based on duration, but converting into seconds, because it is the useful SI unit.
 * @returns {Number} seconds 
 */
VideoObject.seconds = video => {
	// schema.org says this should be an ISO period string https://en.wikipedia.org/wiki/ISO_8601#Durations
	// our VideoObject.java says it should be a Dt object -- which is probably more useful
	if (!video) return null;
	if (!video.duration) {
		if (!video.videoSeconds) return null;
		// old data format
		video.duration = new Dt({ n: video.videoSeconds, unit: 'SECOND'});
	} 
	// convert Dt to seconds (see Dt.java)
	return Dt.msecs(video.duration) / 1000;
};


/** Normalise an uploader response to a VideoObject */
VideoObject.fromUpload = base => {
	// NB uploader gives "duration" as an integer number of Seconds - VideoObject needs it to be a Dt
	const { url, duration: videoSeconds, mobile } = base;
	const duration = new Dt({ n: base.duration, unit: 'SECOND' });
	return new VideoObject({ url, duration, videoSeconds, format: 'video', mobile });
};
